import { render, staticRenderFns } from "./AppChecklistFields.vue?vue&type=template&id=4b9bd3ba&scoped=true&"
import script from "./AppChecklistFields.vue?vue&type=script&lang=js&"
export * from "./AppChecklistFields.vue?vue&type=script&lang=js&"
import style0 from "./AppChecklistFields.vue?vue&type=style&index=0&id=4b9bd3ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9bd3ba",
  null
  
)

export default component.exports